import React, { useEffect, useState } from 'react';
import { Drawer, Avatar, Button, Divider } from 'antd';
import { useSelector } from 'react-redux';
import { getProfileSummaryApi } from '../services/api';

export default function ProfileDrawer({ open, onClose, onLogout }) {
  // MainLayout's `user` prop is never actually populated (App.jsx renders
  // <MainLayout /> with no props) — Sidebar/HeaderBar already read the real
  // signed-in user straight from redux, so this does the same instead of
  // trusting the dead prop.
  const { user } = useSelector((state) => state.auth);

  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    getProfileSummaryApi()
      .then((res) => setSummary(res.data?.data || res.data || {}))
      .catch(() => setSummary({}))
      .finally(() => setLoading(false));
  }, [open]);

  const fmt = (n) => (typeof n === 'number' ? n.toLocaleString() : (loading ? '…' : 0));

  const stats = [
    { label: 'Orders Managed', value: fmt(summary.ordersManaged) },
    { label: 'Products Listed', value: fmt(summary.productsListed) },
    { label: 'Customers', value: fmt(summary.customers) },
  ];

  const activities = summary.activities || [];

  return (
    <Drawer
      title={null}
      placement="right"
      width={320}
      open={open}
      onClose={onClose}
      styles={{ body: { padding: 0 } }}
    >
      {/* Header band */}
      <div style={{ background: 'linear-gradient(135deg, #2d2255, #534ab7)', padding: '32px 24px 24px', textAlign: 'center' }}>
        <Avatar size={72} style={{ background: '#fff', color: '#534ab7' }}>
  {user?.avatar || "U"}
</Avatar>
        <div style={{ fontSize: 17, fontWeight: 600, color: '#fff' }}>{user?.name}</div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>{user?.role?.name}</div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: 4 }}>{user?.email}</div>
      </div>

      <div style={{ padding: '20px 24px' }}>
        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
          {stats.map(s => (
            <div key={s.label} style={{ background: '#f8f7ff', borderRadius: 10, padding: '10px 8px', textAlign: 'center' }}>
              <div style={{ fontSize: 16, fontWeight: 600, color: '#534ab7' }}>{s.value}</div>
              <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>

        <Divider style={{ margin: '0 0 16px' }} />

        {/* Quick actions */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: '#888', letterSpacing: '0.5px', marginBottom: 10 }}>QUICK ACTIONS</div>
          {[
            { icon: '✏️', label: 'Edit Profile' },
            { icon: '🔑', label: 'Change Password' },
            { icon: '🔔', label: 'Notification Settings' },
            { icon: '🛡️', label: 'Security & Access' },
          ].map(a => (
            <div key={a.label} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:8, cursor:'pointer', marginBottom:2, transition:'background .15s' }}
              onMouseEnter={e => e.currentTarget.style.background='#f5f5f0'}
              onMouseLeave={e => e.currentTarget.style.background='transparent'}
            >
              <span style={{ fontSize:16 }}>{a.icon}</span>
              <span style={{ fontSize:13, color:'#333' }}>{a.label}</span>
            </div>
          ))}
        </div>

        <Divider style={{ margin: '0 0 16px' }} />

        {/* Recent activity */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: '#888', letterSpacing: '0.5px', marginBottom: 10 }}>RECENT ACTIVITY</div>
          {!loading && activities.length === 0 && (
            <div style={{ fontSize: 12, color: '#aaa' }}>No activity yet</div>
          )}
          {activities.map((a, i) => (
            <div key={i} style={{ display:'flex', gap:10, marginBottom:10 }}>
              <div style={{ width:6, height:6, borderRadius:'50%', background:'#534ab7', marginTop:5, flexShrink:0 }} />
              <div>
                <div style={{ fontSize:12, color:'#333', lineHeight:1.5 }}>{a.text}</div>
                <div style={{ fontSize:11, color:'#aaa' }}>{a.time}</div>
              </div>
            </div>
          ))}
        </div>

        <Button
          danger block size="large"
          onClick={onLogout}
          style={{ borderRadius: 10, fontWeight: 500 }}
        >
          Sign Out
        </Button>
      </div>
    </Drawer>
  );
}
